import {Component, input} from '@angular/core';
import {Choice} from '@shared/form/choice/choice';
import {FieldBaseComponent} from '@shared/form/field-base.component';

@Component({
  selector: 'app-choice-base',
  imports: [],
  template: ''
})
export class ChoiceBaseComponent<valueT> extends FieldBaseComponent<valueT> {

  public readonly choices = input.required<Choice<valueT>[]>();

}
